module.exports = __webpack_public_path__ + "img/icon_expect@3x.088af82a.png";